import { Outlet, useLocation } from "react-router-dom";
import Footer from "../footer/Footer";
import LoadingSpinner from "../../loading/Loading";
import ProfileFunction from "../../functions/profileFunction/ProfileFunction";
import { useState } from "react";
import Notification from "../../components/notification/notification";

export default function MainLayout() {
  ProfileFunction();

  const location = useLocation();
  const isChatPage = location.pathname.startsWith("/support/");

  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <LoadingSpinner />
      <Outlet context = {{setIsOpen}} />
      {!isChatPage && <Footer />}

      <Notification isOpen={isOpen} onClose= {() => setIsOpen(false)} />
    </>
  );
}